import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'outcomesGroupComments',
    label: 'Comments',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
